import { Chip, Theme, useTheme } from "@mui/material";
import { LocationModel } from "src/types/location";

const getStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.surface.subtle,
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.fontSizes.xxs,
  px: 0,
  height: 18,
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

function RegionChip({ parent }: { parent: LocationModel }) {
  const theme = useTheme();
  return <Chip component='span' label={parent.LocalName} size='small' sx={getStyles(theme)} title={parent.LocalName} />;
}

export default RegionChip;
